import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ToolbarModule } from '@components/toolbar';
import { LoadingModule } from '@components/loading';
import { ButtonModule } from '@components/button';
import { ToolbarTabsModule } from '@components/toolbar-tabs';
import { InputModule } from '@components/inputs';
import { DiscountTimerModule } from '@components/discount-timer/discount-timer.module';
import { TranslateStringsModule } from '@components/translate-string';
import { VideoPlayerModule } from '@components/video-player/video-player.module';
import { DirectivesModule } from '@directives/directives.module';
import { ProductListModule } from '@shared/product-list/product-list.module';
import { PopUpModule } from '@components/pop-up';
import { CsIconModule } from '@components/icon';
import { RegimenInstructionModule } from '@shared/regimen-instruction/regimen-instruction.module';
import { SwiperModule } from 'swiper/angular';
import { ChoosePlanModule } from '@shared/choose-plan/choose-plan.module';
import { SkinReportSheetModule } from '@shared/bottom-sheet-layouts/skin-report/skin-report-sheet.module';
import { HomeBannersModule } from '@shared/home-banners/home-banners.module';
import { ReportModule } from 'client/app/report/report.module';
import { RefundPolicyModule } from '@shared/refund-policy/refund-policy.module';
import { RegimenPropositionModule } from '@shared/regimen-proposition/regimen-proposition.module';
import { RegimenOfferProductBannerModule } from '@shared/regimen-offer-product-banner/regimen-offer-product-banner.module';
import { TestimonialModule } from 'client/app/testimonial/testimonial.module';
import { RequestCallBannerComponent } from '@shared/pending-call-banners/request-call-banner/request-call-banner.component';
import { CallScheduledBannerComponent } from '@shared/pending-call-banners/call-scheduled-banner/call-scheduled-banner.component';
import { CallCompletedBannerComponent } from '@shared/pending-call-banners/call-completed-banner/call-completed-banner.component';
import {
  DoctorCallUnsuccessfulBannerComponent,
} from '@shared/pending-call-banners/doctor-call-unsuccessful-banner/doctor-call-unsuccessful-banner.component';
import { UserViewRegimenComponent } from './user-view-regimen.component';
import { UserViewRegimenPreparationComponent } from './user-view-regimen-preparation/user-view-regimen-preparation.component';
import { RegimenPrescriptionComponent } from './user-view-regimen-unpaid/prescription/prescription.component';
import { UserViewRegimenUnpaidComponent } from './user-view-regimen-unpaid/user-view-regimen-unpaid.component';
import { UserViewRegimenEmptyComponent } from './user-view-regimen-empty/user-view-regimen-empty.component';
import { AudioModule } from '../user-assistant/user-chat/components/audio/audio.module';
import { ChatV2ViewModule } from '../../../chatV2-view/chatV2-view.module';
import { BannerScrollbarModule } from '../user-home/banner-scrollbar/banner-scrollbar.module';
import { ScrollSpyDirective } from './scroll-spy/scroll-spy.directive';
import { CrossRegimenBannerModule } from '../user-home/cross-regimen-banner/cross-regimen-banner.module';
import { UserViewRegimenConsultationComponent } from './user-view-regimen-consultation/user-view-regimen-consultation.component';
import { UserQueryChatBannerComponent } from '@shared/user-query-chat-banner/user-query-chat-banner.component';
import { RegimenDoctorDetailsCardComponent } from '@shared/regimen-doctor-details-card/regimen-doctor-details-card.component';
import { ChoosePlanRebrandedComponent } from '@shared/choose-plan-rebranded/choose-plan-rebranded.component';
import { RegimenExpiryStripComponent } from '@shared/home-banners/regimen-expiry-strip/regimen-expiry-strip.component';
import { UserViewInstructionsComponent } from '../user-view-instructions/user-view-instructions.component';
import { ButtonCtaComponent } from "@components/button-cta/button-cta.component";
import { UnpaidUserDoctorCallBannerContainerComponent } from '@shared/pending-call-banners/unpaid-user-doctor-call-banner-container/unpaid-user-doctor-call-banner-container.component';
import { RegimenValuePropositionV2Component } from '@shared/regimen-value-proposition-v2/regimen-value-proposition-v2.component';
import { MoneyBackGuaranteeBannerComponent } from '@shared/money-back-guarentee/money-back-guarantee-banner.component';
import { RegimenEmptyStateComponent } from './user-view-regimen-empty/regimen-empty-state/regimen-empty-state.component';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    SwiperModule,
    ToolbarModule,
    RouterModule,
    LoadingModule,
    CsIconModule,
    ButtonModule,
    ToolbarTabsModule,
    DirectivesModule,
    DiscountTimerModule,
    InputModule,
    ProductListModule,
    TranslateStringsModule,
    VideoPlayerModule,
    RegimenInstructionModule,
    ChatV2ViewModule,
    PopUpModule,
    AudioModule,
    CrossRegimenBannerModule,
    BannerScrollbarModule,
    ChoosePlanModule,
    TestimonialModule,
    ReportModule,
    SkinReportSheetModule,
    RefundPolicyModule,
    HomeBannersModule,
    RegimenPropositionModule,
    RegimenOfferProductBannerModule,
    RequestCallBannerComponent,
    CallScheduledBannerComponent,
    CallCompletedBannerComponent,
    DoctorCallUnsuccessfulBannerComponent,
    UserQueryChatBannerComponent,
    RegimenDoctorDetailsCardComponent,
    ChoosePlanRebrandedComponent,
    RegimenExpiryStripComponent,
    UserViewInstructionsComponent,
    ButtonCtaComponent,
    UnpaidUserDoctorCallBannerContainerComponent,
    RegimenValuePropositionV2Component,
    MoneyBackGuaranteeBannerComponent,
    RegimenEmptyStateComponent
],
  declarations: [
    UserViewRegimenComponent,
    UserViewRegimenConsultationComponent,
    UserViewRegimenPreparationComponent,
    UserViewRegimenUnpaidComponent,
    UserViewRegimenEmptyComponent,
    RegimenPrescriptionComponent,
    ScrollSpyDirective,
  ],
  exports: [UserViewRegimenComponent],
})
export class UserViewRegimenModule {
}
